module.exports = __webpack_public_path__ + "static/media/SolutionsSecond.6b17ead7.png";